
import React from 'react';
import Layout from '@/components/Layout/Layout';
import CurrencyConverter from '@/components/UnitConverter/CurrencyConverter';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const CurrencyConverterPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/converters" className="flex items-center text-primary hover:underline mb-2 font-bold">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Converters
          </Link>
          <h1 className="text-3xl font-bold mb-2">Currency Converter</h1>
          <p className="text-gray-600 mb-6">
            Convert between different currencies from around the world with up-to-date exchange rates.
          </p>
        </div>
        
        <div className="mb-8">
          <CurrencyConverter />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Currency Converter</h2>
          <p>
            Our currency converter tool will provide real-time currency exchange rates for major currencies worldwide.
            Whether you're planning a trip abroad, managing international business, or just curious about exchange rates,
            this converter will help you make accurate currency conversions.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Coming Soon</h3>
          <p>
            We're currently developing this feature to support all major world currencies with regularly updated
            exchange rates. Check back soon for the complete functionality!
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default CurrencyConverterPage;
